var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "text" }, [
        _vm._v(
          "请选择对应新的区域结构，此操作会更新合同销售区域以及部分窜货信息："
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }